import React, { useContext, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
} from "@mui/material";

import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";

import CachedIcon from "@mui/icons-material/Cached";

import * as XLSX from "xlsx";
import DescriptionIcon from "@mui/icons-material/Description";

import AuthContext from "../store/AuthContext";
import ApiPaginateSearch from "../component/ApiPaginateSearch";
import ApiEndpoints from "../network/ApiEndPoints";
import { CustomStyles } from "../component/CustomStyle";
import DataFilter from "./Biggbarains/Common/DataFilter";
import PunishedLeaveModal from "../modals/PunishedLeaveModal";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  bgcolor: "background.paper",
  boxShadow: 24,
  fontFamily: "Poppins",
  p: 2,
};
const PunishedLeave = () => {
  const [request, setRequest] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [selectedLeave, setSelectedLeave] = useState(null);
  const [leaveStatus, setLeaveStatus] = useState({});
  const [apiData, setApiData] = useState([]);
  const [query, setQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState(""); // ✅ new state for status filter
  const authCtx = useContext(AuthContext);
  const user = authCtx.user;

  let refresh;

  const refreshFunc = () => {
    setQuery("");
    setStatusFilter("");
    if (refresh) refresh();
  };

  const columns = [
    {
      name: "Created At",
      selector: (row) =>
        row.created_at ? new Date(row.created_at).toLocaleString() : "NA",
    },
    { name: "Employee ID", selector: (row) => row.user_id },
    { name: "Employee Name", selector: (row) => row.emp_name },
    { name: "Leave Type", selector: (row) => row.leave_type?.toUpperCase() },
    { name: "Status", selector: (row) => row.status },
    // {
    //   name: "Days",
    //   selector: (row) =>
    //     row.leave_type === "compensatory"
    //       ? row.total_compensatory
    //       : row.days || "-",
    // },
    { name: "Reason", selector: (row) => row.reason || "NA" },
    { name: "Remark", selector: (row) => row.remark || "NA" },
    { name: "Handled By", selector: (row) => row.handled_by || "System" },
  ];

  return (
    <Box sx={{ mt: 3 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
        }}
      >
        <DataFilter
          ifemployeeFilter={user.role === "Admin"}
          ifPunishmentTypeFilter={true}
          setQuary={setQuery}
        />

        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Button
            variant="contained"
            sx={{ bgcolor: "#0F52BA" }}
            onClick={() => setOpenModal(true)}
          >
            Add / Deduct Leave
          </Button>

          <Tooltip title="Refresh">
            <IconButton
              aria-label="refresh"
              sx={{ color: "#0F52BA" }}
              onClick={refreshFunc}
            >
              <CachedIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      <ApiPaginateSearch
        apiEnd={ApiEndpoints.GET_LEAVE}
        queryParam={`punishment=true${
          statusFilter ? `&status=${statusFilter}` : ""
        }${query ? `&${query}` : ""}`}
        columns={columns}
        apiData={apiData}
        setApiData={setApiData}
        tableStyle={CustomStyles}
        returnRefetch={(ref) => {
          refresh = ref;
        }}
      />

      {openModal && (
        <PunishedLeaveModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          refresh={refreshFunc}
        />
      )}
    </Box>
  );
};

export default PunishedLeave;
